"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var styled_components_1 = __importDefault(require("styled-components"));
var Box_1 = __importDefault(require("./Box"));
var gridTheme_1 = __importDefault(require("../gridTheme"));
var theme_1 = require("../theme");
var hideOn = function (size, props) {
    return typeof props["hideOn" + size[0].toUpperCase() + size.slice(1).toLowerCase()] !== 'undefined'
        ? "\n      " + theme_1.createMediaQuery(gridTheme_1["default"].breakpoints[size]) + " {\n        display: none;\n      }\n    "
        : "";
};
var hideOnCustomSize = function (props) {
    return typeof props.hideOn !== 'undefined'
        ? "\n    " + theme_1.createMediaQuery(props.hideOn) + " {\n      display: none;\n    }\n  "
        : "";
};
var showOn = function (size, props) {
    return typeof props["showOn" + size[0].toUpperCase() + size.slice(1).toLowerCase()] !== 'undefined'
        ? "\n      " + theme_1.createMediaQuery(gridTheme_1["default"].breakpoints[size]) + " {\n        display: block;\n      }\n    "
        : "";
};
var showOnCustomSize = function (props) {
    return typeof props.showOn !== 'undefined'
        ? "\n    " + theme_1.createMediaQuery(props.showOn) + " {\n      display: block;\n    }\n  "
        : "";
};
var ResponsiveBox = styled_components_1["default"](Box_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n"])), function (props) { return hideOn('xs', props); }, function (props) { return hideOn('sm', props); }, function (props) { return hideOn('md', props); }, function (props) { return hideOn('lg', props); }, function (props) { return hideOnCustomSize(props); }, function (props) { return showOn('xs', props); }, function (props) { return showOn('sm', props); }, function (props) { return showOn('md', props); }, function (props) { return showOn('lg', props); }, function (props) { return showOnCustomSize(props); }, function (props) { return (typeof props.show !== 'undefined' ? "display: block;" : null); }, function (props) { return (typeof props.hide !== 'undefined' ? "display: none;" : null); });
ResponsiveBox.displayName = 'ResponsiveBox';
exports["default"] = ResponsiveBox;
var templateObject_1;
//# sourceMappingURL=ResponsiveBox.js.map